import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Box,
  Grid,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  useMediaQuery,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import styles from "../InternalTracker.module.css";

import {
  convertArrayToString,
  customTextColor,
  formatDate,
  ShortenName2,
  splitIntoColumns,
} from "../../../utils/const";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PiAddressBookLight, PiBuildingOfficeLight } from "react-icons/pi";
import { PiUserLight } from "react-icons/pi";
import { allSkill } from "../../../redux/common/skillSlice";
import {
  getNextTrackerDetailas,
  getOneTrackerDetails,
  getTrackerDetails,
  getTrackerSubmisionCount,
  internalCandidateRequirementList,
  internalCompanyTrackingCount,
  postInternalViewcount,
  updateTrackerAction,
} from "../../../redux/internal-tracking/InternalTrackerSlice";
import { BsThreeDotsVertical } from "react-icons/bs";
import { PiMailboxLight } from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import InternalTrackerDrawer from "./InternalTrackerDrawer";
import { PiIdentificationCardLight } from "react-icons/pi";
import { PiChairLight } from "react-icons/pi";
import "./userProfile.css";
import { allLocation } from "../../../redux/common/locationSlice";
import { allWorkAuthorization } from "../../../redux/common/workAuthorizationSlice";
import InternalTrackerCommentDrawer from "./InternalTrackerCommentDrawer";
import { Icon } from "@iconify/react/dist/iconify.js";
import SideFlexScreen from "../../../components/containers/SideFlexScreen";
import { GrNext } from "react-icons/gr";

const InternalCandidateViewdrawer = ({ handleClose, show, row, type }) => {
  const [showSubmission, setShow] = useState(false);
  const [showComments, setShowComment] = useState(false);

  const [open, setOpen] = useState(false);
  const [detailsBtnType, setDetailsBtnType] = useState("false");
  const [openAction, setOpenAction] = useState(false);
  const [actionName, setActionName] = useState("");
  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseCommentShow = () => setShowComment(false);
  const handleCommentShow = () => setShowComment(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location) || [];
  const skillData = useSelector((state) => state.skill.data);
  const candidateDetails = useSelector(
    (state) => state.tracker.candidateDetails
  );

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const candidateTrackerStatus = useSelector((state) => state.tracker.status);
  const candidateTrackerStatusForDetails = useSelector(
    (state) => state.tracker.candidateDetailStatus
  );

  const candidateDetailsSubmisionList = useSelector(
    (state) => state.tracker.candidateDetailsSubmisionList
  );
  const candidateDetailsSubmisionCount = useSelector(
    (state) => state.tracker.candidateDetailsSubmisionCount
  );

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };

  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const matchingSkills = skillData?.locations?.filter((skill) =>
    candidateDetails?.data?.skills?.includes(skill.id)
  );
  const columns = splitIntoColumns(matchingSkills, 4);

  const matchingSkills2 = skillData?.locations?.filter((skill) =>
    candidateDetails?.data?.secondary_skills?.includes(skill.id)
  );
  const columns2 = splitIntoColumns(matchingSkills2, 4);

  useEffect(() => {
    dispatch(allSkill());
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, []);

  useEffect(() => {
    if (candidateDetails?.data?.email) {
      let parameter = candidateDetails?.data?.email;
      dispatch(getTrackerSubmisionCount(parameter));
    }
  }, [candidateDetails]);

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleCloseAction = () => {
    setOpenAction(false);
  };

  const handleOnClickChangeAction = () => {
    let updatedValues = {
      job_status: actionName,
    };
    let id = candidateDetails?.data?.id;
    dispatch(updateTrackerAction({ updatedValues, id }));
  };

  useEffect(() => {
    if (candidateTrackerStatus === "update_candidate_tracker_action") {
      let queryString = `page=1&page_size=10`;
      dispatch(getTrackerDetails(queryString));
      handleCloseModal();
      handleCloseAction();
    }
  }, [candidateTrackerStatus, row]);

  useEffect(() => {
    if (Object.keys(row).length > 0) {
      let ID = row?.id;
      let candidate_id = row?.id;
      let candidate_email = row?.email;
      setActionName(row?.job_status);
      dispatch(getOneTrackerDetails(ID));
      dispatch(internalCandidateRequirementList(candidate_email));
      dispatch(postInternalViewcount(candidate_id));
      dispatch(internalCompanyTrackingCount({ candidate_id, candidate_email }));
    }
  }, [row]);

  const handleOnClickNextProfile = (status) => {
    if (candidateDetails) {
      if (status === "prev") {
        setDetailsBtnType("prev");
        dispatch(getNextTrackerDetailas(candidateDetails?.previous));
      } else {
        setDetailsBtnType("next");
        dispatch(getNextTrackerDetailas(candidateDetails?.next));
      }
    }
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "64px",
        width: "65%",
        // padding: "0 0 0 10px",
        backgroundColor: "#f5f5f5",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#fff",
          padding: "3px 10px 3px 0",
          margin: "0 15px",
        }}
      >
        <Box className={styles.job_serach_result_heading} sx={{ margin: "0" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <GrNext
              style={{
                fontSize: "22px",
                cursor: "pointer",
                color: customTextColor,
                marginRight: "20px",
              }}
              onClick={handleClose}
            />
            <span onClick={() => setShowComment(!showComments)}>
              <span
                style={{
                  marginRight: "10px",
                  backgroundColor: "#e4e6eb",
                  padding: "6px 8px",
                  borderRadius: "2px",
                  color: "rgb(76, 104, 176)",
                }}
              >
                <Icon
                  icon="teenyicons:message-plus-outline"
                  height={20}
                  width={20}
                />
              </span>
              <span style={{ textDecoration: "underline", fontWeight: "600" }}>
                Add Comment{" "}
              </span>
            </span>
          </Box>
        </Box>

        {/* <Box> */}
        {type !== "public" && type !== "community" && (
          <span style={{ display: "flex", alignItems: "center" }}>
            <Typography>
              {candidateDetails?.data?.filled_percentage}%
            </Typography>
            <span
              style={{ marginLeft: "10px" }}
              className={styles.view_profile_link}
              onClick={() => {
                navigate("/internal-tracker-add");
                localStorage.setItem(
                  "internalTrackerCandidateAddOrUpdate",
                  JSON.stringify({
                    row: candidateDetails?.data,
                    types: "view_update",
                  })
                );
              }}
            >
              Profile Completed
            </span>
            <BsThreeDotsVertical
              onClick={handleShow}
              style={{
                fontSize: "20px",
                marginLeft: "10px",
                cursor: "pointer",
              }}
            />
          </span>
        )}
      </Offcanvas.Header>
      <Offcanvas.Body sx={{ padding: "0 !important" }}>
        {candidateTrackerStatusForDetails === "loading" ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 230,
            }}
          >
            <CircularProgress size={30} color="info" />
          </Box>
        ) : (
          <Box className={styles.add_structure} sx={{ margin: "0" }}>
            <Box
              className={styles.profile_and_submit}
              sx={{ padding: "10px 15px 5px", margin: "0 0 14px" }}
            >
              <Box>
                <Typography>
                  Activities Since:{" "}
                  <b>
                    {candidateDetails?.data?.created_at !== undefined &&
                      formatDate(candidateDetails?.data?.created_at)}
                  </b>
                </Typography>
                <Typography sx={{ marginBottom: "0 !important" }}>
                  Profile Credited by
                </Typography>
                <Typography>
                  <b> {candidateDetails?.data?.profile_created_by}</b>
                </Typography>
                {/* <Typography>Active Mutual 17</Typography> */}
              </Box>
              <a
                className={styles.phase2}
                href={candidateDetails?.data?.resume}
                target="_blank"
                style={{ textDecoration: "none", color: "#374151" }}
              >
                <Box
                  sx={{
                    backgroundColor: "#e4e6eb",
                    padding: "4px",
                    borderRadius: "3px",
                  }}
                >
                  <Tooltip title="Download Resume" arrow>
                    <Icon icon="pepicons-pencil:cv" height={50} width={50} />
                  </Tooltip>
                </Box>
                <Typography sx={{ marginTop: "5px" }}>Get Resume</Typography>
              </a>
            </Box>

            <Grid
              container
              className={styles.profile_phase}
              sx={{ backgroundColor: "#fff", marginBottom: "15px" }}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{
                  border: "none !important",
                  marginBottom: "15px !important",
                }}
              >
                <Typography sx={{ marginLeft: "0 !important" }}>
                  <PiUserLight
                    style={{
                      fontSize: "33px",
                      backgroundColor: "#f2f2f2",
                      padding: "4px",
                      borderRadius: "3px",
                      color: "#4c68b0",
                    }}
                  />

                  <b style={{ marginLeft: "10px" }}>
                    {" "}
                    {candidateDetails?.data?.full_name}
                  </b>
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ marginBottom: "15px !important" }}
              >
                <Typography>
                  {" "}
                  <PiChairLight
                    style={{
                      fontSize: "33px",
                      backgroundColor: "#f2f2f2",
                      padding: "4px",
                      borderRadius: "3px",
                      color: "#4c68b0",
                    }}
                  />
                  <b style={{ marginLeft: "10px" }}>
                    {ShortenName2(candidateDetails?.data?.current_job_title)}{" "}
                  </b>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography sx={{ marginLeft: "0 !important" }}>
                  <PiAddressBookLight
                    style={{
                      fontSize: "33px",
                      backgroundColor: "#f2f2f2",
                      padding: "4px",
                      borderRadius: "3px",
                      color: "#4c68b0",
                    }}
                  />

                  <b style={{ marginLeft: "10px" }}>
                    {candidateDetails?.data?.total_experience}{" "}
                    {candidateDetails?.data?.total_experience > 1
                      ? "Years"
                      : "Year"}{" "}
                    Experience
                  </b>
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ color: customTextColor }}
              >
                <Typography>
                  <PiIdentificationCardLight
                    style={{
                      fontSize: "33px",
                      backgroundColor: "#f2f2f2",
                      padding: "4px",
                      borderRadius: "3px",
                      color: "#4c68b0",
                    }}
                  />

                  <b style={{ marginLeft: "10px" }}>
                    {getWorkAuthorization(
                      candidateDetails?.data?.work_authorization
                    )}
                  </b>
                </Typography>
              </Grid>
            </Grid>

            <Box className={styles.matches_and_submit}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ color: customTextColor }}
                >
                  <Box>
                    <ul
                      style={{
                        listStyleType: "square",
                        padding: "5px 20px",
                        marginBottom: "10px",
                      }}
                    >
                      <Box>
                        <li>
                          <Typography>
                            Current Location:{" "}
                            <b>
                              {getLocationById(
                                candidateDetails?.data?.current_location
                              )}
                            </b>
                          </Typography>
                        </li>
                      </Box>
                      <Box>
                        <li>
                          <Typography>
                            Tax Term:{" "}
                            <b>
                              {convertArrayToString(
                                candidateDetails?.data?.p_tax_team
                              )}
                            </b>
                          </Typography>
                        </li>
                      </Box>
                      <Box>
                        <li>
                          <Typography>
                            Work Preference:{" "}
                            <b>{candidateDetails?.data?.work_preference}</b>
                          </Typography>
                        </li>
                      </Box>
                      <Box>
                        <li>
                          <Typography>
                            Domain & Industry:{" "}
                            <b>{candidateDetails?.data?.domain_name}</b>
                          </Typography>
                        </li>
                      </Box>
                      <Box>
                        <li>
                          <Typography sx={{ marginBottom: "0 !important" }}>
                            Qualifications:{" "}
                            <b>
                              {" "}
                              {candidateDetails?.data?.highest_qualification}
                            </b>
                          </Typography>
                        </li>
                      </Box>
                    </ul>
                  </Box>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{
                    color: customTextColor,
                    // display: "flex",
                    // alignItems: "flex-start",
                    // justifyContent: "space-between",
                    position: "relative", // Parent must be relative for absolute children
                    overflow: "visible",
                  }}
                >
                  <Box>
                    <ul
                      style={{
                        listStyleType: "square",
                        padding: "5px 20px",
                        marginBottom: "10px",
                      }}
                    >
                      <Box>
                        <li>
                          <Typography>
                            Prefer Location:{" "}
                            <b>
                              {getPreferLocationNames(
                                candidateDetails?.data?.prefer_location
                              )}
                            </b>
                          </Typography>
                        </li>
                      </Box>
                      {/* 
                    {candidateDetails?.data?.p_tax_team?.includes(
                      "full_Time"
                    ) && candidateDetails?.data?.p_tax_team?.length > 1 ? (
                      ""
                    ) : ( */}
                      <Box>
                        <li>
                          <Typography>
                            {candidateDetails?.data?.p_tax_team?.includes(
                              "full_Time"
                            )
                              ? "Salary"
                              : "Rate"}
                            :{" "}
                            <b>
                              ${candidateDetails?.data?.rate}
                              {candidateDetails?.data?.p_tax_team?.includes(
                                "full_Time"
                              )
                                ? "K Yearly"
                                : " Hourly"}
                            </b>
                          </Typography>
                        </li>
                      </Box>
                      {/* // )} */}
                      <Box>
                        <li>
                          <Typography>
                            Current Organization:{" "}
                            <b>{candidateDetails?.data?.current_company} </b>
                          </Typography>
                        </li>
                      </Box>
                      <Box>
                        <li>
                          <Typography>
                            University:{" "}
                            <b>{candidateDetails?.data?.university}</b>
                          </Typography>
                        </li>
                      </Box>
                      <Box>
                        <li>
                          <Typography sx={{ marginBottom: "0 !important" }}>
                            Linked in Profile:{" "}
                            <b>
                              {candidateDetails?.data?.linkedin_profile_url}
                            </b>
                          </Typography>
                        </li>
                      </Box>
                    </ul>
                  </Box>
                  {type !== "community" && (
                    <SideFlexScreen
                      userInfo={candidateDetails?.data}
                      count={candidateDetailsSubmisionCount?.total_views}
                    />
                  )}
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ padding: "14px 0" }}>
              <Grid container sx={{ backgroundColor: "#fff" }}>
                <Grid item xs={12}>
                  <Box className={styles.list_details}>
                    <Typography sx={{ marginBottom: "20px !important" }}>
                      <b> Primary skills</b>
                    </Typography>
                    <Grid container sx={{ fontWeight: "600" }}>
                      {columns.map((column, colIndex) => (
                        <Grid
                          item
                          xs={6}
                          sm={6}
                          md={3}
                          lg={3}
                          key={colIndex}
                          sx={{
                            borderLeft:
                              colIndex !== 0 ? "2px solid white" : "none",
                            paddingLeft: colIndex !== 0 ? "20px" : "0",
                          }}
                        >
                          <Box sx={{ color: customTextColor }}>
                            {column.map((skill) => (
                              <Typography
                                key={skill.id}
                                sx={{ marginBottom: "0 !important" }}
                              >
                                {skill.name}
                              </Typography>
                            ))}
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              <Grid
                container
                sx={{ backgroundColor: "#fff", margin: "14px 0" }}
              >
                <Grid item xs={12}>
                  <Box className={styles.list_details}>
                    <Typography sx={{ marginBottom: "20px !important" }}>
                      <b> Secondary skills</b>
                    </Typography>
                    <Grid container sx={{ fontWeight: "600" }}>
                      {columns2.map((column, colIndex) => (
                        <Grid
                          item
                          xs={6}
                          sm={6}
                          md={3}
                          lg={3}
                          key={colIndex}
                          sx={{
                            borderLeft:
                              colIndex !== 0 ? "2px solid white" : "none",
                            paddingLeft: colIndex !== 0 ? "20px" : "0",
                          }}
                        >
                          <Box sx={{ color: customTextColor }}>
                            {column.map((skill) => (
                              <Typography
                                key={skill.id}
                                sx={{ marginBottom: "0 !important" }}
                              >
                                {skill.name}
                              </Typography>
                            ))}
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ backgroundColor: "#fff", padding: "10px" }}>
              <Box className={styles.experience_details}>
                <Box>
                  <Typography
                    sx={{ fontSize: "18px !important", marginLeft: "10px" }}
                  >
                    <b>Professional Experience</b>
                  </Typography>
                </Box>
              </Box>
              {candidateDetails?.data?.previous_experience ? (
                JSON?.parse(candidateDetails?.data?.previous_experience)?.map(
                  (prevData, index) => {
                    return (
                      <Box className={styles.full_details} key={index}>
                        <Box sx={{ marginLeft: "20px" }}>
                          <Typography>
                            <b>{prevData?.role}</b>
                          </Typography>
                          <Typography>{prevData?.company}</Typography>
                          <Typography>
                            {prevData?.industry_of_the_company}
                          </Typography>
                          <Typography
                            sx={{
                              display: "flex",
                              justifyContent: "end",
                              position: "relative",
                              bottom: "60px",
                              marginTop: "10px",
                              marginRight: "20px",
                            }}
                          >
                            {prevData?.duration_from} to {prevData?.duration_to}
                          </Typography>
                        </Box>
                        <ul>
                          {prevData?.summary_of_work.map((text, index) => (
                            <li key={index}>{text}</li>
                          ))}
                        </ul>
                      </Box>
                    );
                  }
                )
              ) : (
                <p>No Experience Found</p>
              )}
            </Box>

            {candidateDetails?.data?.referrer_company_name === "" &&
            candidateDetails?.data?.referrer_email === "" &&
            candidateDetails?.data?.referrer_manager_name === "" &&
            candidateDetails?.data?.referrer_mobile_no === "" ? (
              ""
            ) : (
              <Grid
                container
                className={styles.candidates_name}
                sx={{ marginBottom: "14px" }}
              >
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Grid
                    container
                    className={styles.requirement_details_view}
                    sx={{ color: customTextColor, padding: "10px" }}
                  >
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <span>
                        <Box>
                          <PiUserLight
                            style={{
                              fontSize: "33px",
                              backgroundColor: "#f2f2f2",
                              padding: "4px",
                              borderRadius: "3px",
                            }}
                          />
                          <Typography>
                            Reference Manager Name:{" "}
                            <b>
                              {candidateDetails?.data?.referrer_manager_name}
                            </b>
                          </Typography>
                        </Box>
                        <Box sx={{ marginBottom: "0 !important" }}>
                          <PiMailboxLight
                            style={{
                              fontSize: "33px",
                              backgroundColor: "#f2f2f2",
                              padding: "4px",
                              borderRadius: "3px",
                            }}
                          />
                          <Typography>
                            Reference Email ID :
                            <b> {candidateDetails?.data?.referrer_email} </b>
                          </Typography>
                        </Box>
                      </span>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <span>
                        <Box>
                          <PiBuildingOfficeLight
                            style={{
                              fontSize: "33px",
                              backgroundColor: "#f2f2f2",
                              padding: "4px",
                              borderRadius: "3px",
                            }}
                          />
                          <Typography>
                            Reference Company Name:{" "}
                            <b>
                              {candidateDetails?.data?.referrer_company_name}
                            </b>
                          </Typography>
                        </Box>

                        <Box sx={{ marginBottom: "0 !important" }}>
                          <CiMobile3
                            style={{
                              fontSize: "33px",
                              backgroundColor: "#f2f2f2",
                              padding: "4px",
                              borderRadius: "3px",
                            }}
                          />
                          <Typography>
                            Reference Phone No:{" "}
                            <b>{candidateDetails?.data?.referrer_mobile_no} </b>
                          </Typography>
                        </Box>
                      </span>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}

            {candidateDetails?.data?.p_tax_team?.includes("full_Time") ? (
              ""
            ) : (
              <Grid
                container
                className={styles.candidates_name}
                sx={{ marginBottom: "14px" }}
              >
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Grid
                    container
                    className={styles.requirement_details_view}
                    sx={{ color: customTextColor, padding: "10px" }}
                  >
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <span>
                        <Box>
                          <PiUserLight
                            style={{
                              fontSize: "33px",
                              backgroundColor: "#f2f2f2",
                              padding: "4px",
                              borderRadius: "3px",
                            }}
                          />
                          <Typography>
                            Employer Manager Name:{" "}
                            <b>
                              {candidateDetails?.data?.employer_manager_name}
                            </b>
                          </Typography>
                        </Box>
                        <Box sx={{ marginBottom: "0 !important" }}>
                          <PiMailboxLight
                            style={{
                              fontSize: "33px",
                              backgroundColor: "#f2f2f2",
                              padding: "4px",
                              borderRadius: "3px",
                            }}
                          />
                          <Typography>
                            Employer Email ID :
                            <b> {candidateDetails?.data?.employer_email} </b>
                          </Typography>
                        </Box>
                      </span>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <span>
                        <Box>
                          <PiBuildingOfficeLight
                            style={{
                              fontSize: "33px",
                              backgroundColor: "#f2f2f2",
                              padding: "4px",
                              borderRadius: "3px",
                            }}
                          />
                          <Typography>
                            Employer Company Name:{" "}
                            <b>
                              {candidateDetails?.data?.employer_company_name}
                            </b>
                          </Typography>
                        </Box>

                        <Box sx={{ marginBottom: "0 !important" }}>
                          <CiMobile3
                            style={{
                              fontSize: "33px",
                              backgroundColor: "#f2f2f2",
                              padding: "4px",
                              borderRadius: "3px",
                            }}
                          />
                          <Typography>
                            Employer Phone No:{" "}
                            <b>{candidateDetails?.data?.employer_mobile_no} </b>
                          </Typography>
                        </Box>
                      </span>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}

            <Box sx={{ backgroundColor: "#fff", padding: "10px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                }}
              >
                <Typography>
                  <b>15 Days Internal Company Activities</b>
                </Typography>
                <Typography>
                  <b>My Activates</b>{" "}
                </Typography>
              </Box>

              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  sx={{
                    padding: "5px",
                  }}
                >
                  <Typography
                    sx={{
                      padding: "10px",
                      border: "1px solid #f2f2f2",
                      borderRadius: "3px",
                    }}
                  >
                    <b>{candidateDetailsSubmisionCount?.total_views}</b> Profile
                    Views
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  sx={{
                    padding: "5px",
                  }}
                >
                  <Typography
                    sx={{
                      padding: "10px",
                      border: "1px solid #f2f2f2",
                      borderRadius: "3px",
                    }}
                  >
                    <b>
                      {
                        candidateDetailsSubmisionCount?.total_internal_submission
                      }
                    </b>{" "}
                    Internal Submission
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  sx={{
                    padding: "5px",
                  }}
                >
                  <Typography
                    sx={{
                      padding: "10px",
                      border: "1px solid #f2f2f2",
                      borderRadius: "3px",
                    }}
                  >
                    <b>
                      {candidateDetailsSubmisionCount?.total_client_submission}
                    </b>{" "}
                    Client Submission
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  sx={{
                    padding: "5px",
                  }}
                >
                  <Typography
                    sx={{
                      padding: "10px",
                      border: "1px solid #f2f2f2",
                      borderRadius: "3px",
                    }}
                  >
                    <b>{candidateDetailsSubmisionCount?.total_interview}</b>{" "}
                    Interview
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            <Box className={styles.internal_update_btns}>
              <Box>
                <button
                  style={{
                    backgroundColor: "#3856a6 ",
                    padding: "7.5px 15px ",
                  }}
                  onClick={() => handleOnClickNextProfile("prev")}
                  disabled={
                    candidateTrackerStatus === "loading" ||
                    candidateTrackerStatusForDetails === "loading" ||
                    candidateDetails?.previous === undefined
                  }
                >
                  {(candidateTrackerStatus === "loading" ||
                    candidateTrackerStatusForDetails === "loading") &&
                  detailsBtnType === "prev"
                    ? "Loading"
                    : "Previous Profile"}
                </button>
              </Box>
              <Box>
                <button
                  style={{
                    backgroundColor: "#3856a6 ",
                    padding: "7.5px 15px ",
                  }}
                  onClick={() => handleOnClickNextProfile("next")}
                  disabled={
                    candidateTrackerStatus === "loading" ||
                    candidateTrackerStatusForDetails === "loading" ||
                    candidateDetails?.next === undefined
                  }
                >
                  {(candidateTrackerStatus === "loading" ||
                    candidateTrackerStatusForDetails === "loading") &&
                  detailsBtnType === "next"
                    ? "Loading"
                    : "Next Profile"}
                </button>
              </Box>
            </Box>

            <InternalTrackerDrawer
              handleShow={handleShow}
              handleClose={handleCloseShow}
              show={showSubmission}
              row={row}
              getLocationById={getLocationById}
              getPreferLocationNames={getPreferLocationNames}
              getWorkAuthorization={getWorkAuthorization}
              candidateDetailsSubmisionList={candidateDetailsSubmisionList}
            />

            <InternalTrackerCommentDrawer
              handleShow={handleCommentShow}
              handleClose={handleCloseCommentShow}
              show={showComments}
              candidateDetails={candidateDetails}
            />
          </Box>
        )}

        <Dialog
          fullScreen={fullScreen}
          open={open}
          maxWidth="md"
          aria-labelledby="responsive-dialog-title"
          fullWidth={true}
        >
          <Box>
            <DialogTitle
              id="responsive-dialog-title"
              sx={{ textAlign: "center" }}
            >
              <b>Job Action Change</b>
            </DialogTitle>
            <DialogContent sx={{ textAlign: "center" }}>
              Are you sure you want to change action to {actionName}
            </DialogContent>
            <Box>
              <Box className={styles.adding_internal_btns}>
                <button
                  sx={{ backgroundColor: "#2d73b5" }}
                  onClick={handleOnClickChangeAction}
                >
                  Yes
                </button>
                <button
                  sx={{ backgroundColor: "#97B6F1" }}
                  onClick={handleCloseModal}
                >
                  No
                </button>
              </Box>
            </Box>
          </Box>
        </Dialog>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default InternalCandidateViewdrawer;
